import {GET, POST} from "../util";

const inspectionUrl = "api/user/walbing-referrer/inspection";

const url = {
    inspection: {
        config: `${inspectionUrl}/config`,
        listReferrals: `${inspectionUrl}/list-referrals`,
    }
};
const walbingReferrerApi = {
    inspection: {
        getConfig: () => {
            return GET(url.inspection.config);
        },
        listReferrals: (params) => {
            return POST(url.inspection.listReferrals, params);
        }
    }
};
export {
    walbingReferrerApi
};